<div mat-dialog-content>
  <div class="col-12">
    {{log.sequenceNumber}}
    <button *ngIf="!log.validated" class="btn btn-secondary scanner" style="right: 0px; position: absolute;"
        mat-raised-button color="primary" (click)="validateScout(log, true)">
          <p class="text btn-text">
            VERIFY
          </p>
    </button>
    <button *ngIf="log.validated" class="btn btn-secondary scanner" style="right: 0px; position: absolute;"
        mat-raised-button color="primary" (click)="unValidateScout(log, true)">
          <p class="text btn-text">
            RETURN
          </p>
    </button>
  </div>
  <br>
  <hr>
</div>
<div mat-dialog-actions>
  <div class="col-12">
    <mat-form-field id="form-input">
      <input matInput placeholder="Search Serial" [(ngModel)]="input">
    </mat-form-field>
  </div>

<!-- <div mat-dialog-actions>
  <button mat-button color="warn" (click)="onNoClick()">No</button>
  <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</div> -->